import { kegLitresLabelFromUnitMl } from 'util/dtc-shopify-barcode';

function packConfigLookup(formData, packConfigs) {
  const key = formData.dtcPackConfigKey ?? formData.unitSize;
  return packConfigs[key];
}

export const baseVariant = (formData, baseWeight, floatedRRP, packConfigs, unitBarcode) => {
  const cfg = packConfigLookup(formData, packConfigs);
  const typeTag = cfg.type || 'Can';
  const litreLabel = typeTag === 'Keg'
    ? `${kegLitresLabelFromUnitMl(formData.kegMl) ?? formData.unitSize}L Keg`
    : `${formData.unitSize}ml Single ${typeTag}`;
  return {
    title: litreLabel,
    option1: litreLabel,
    price: floatedRRP.toFixed(2),
    inventory_management: 'shopify',
    sku: `${formData.SKU}-${formData.unitSize}`,
    grams: baseWeight,
    weight: baseWeight / 1000,
    weight_unit: 'kg',
    barcode: unitBarcode,
    metafields: [
      {
        key: 'bundle_base',
        value: true,
        type: 'boolean',
        namespace: 'global',
      },
      {
        key: 'bundle_quant',
        value: 1,
        type: 'number_integer',
        namespace: 'global',
      },
    ],
  };
};
export const packVariant = (title, count, formData, baseWeight, price, packConfigs) => ({
  title,
  option1: title,
  price,
  inventory_management: 'shopify',
  sku: `${formData.SKU}-${formData.unitSize}-${count}`,
  grams: baseWeight * count,
  weight: (baseWeight * count) / 1000,
  weight_unit: 'kg',
  metafields: [
    {
      key: 'bundle_base',
      value: false,
      type: 'boolean',
      namespace: 'global',
    },
    {
      key: 'bundle_quant',
      value: count,
      type: 'number_integer',
      namespace: 'global',
    },
  ],
});
